import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useCreateCampaign = ({
  getAllCampaigns = () => {},
  onReset = () => {},
  onCloseModal = () => {},
}) => {
  const navigate = useNavigate();
  const [isCampaignCreating, setIsCampaignCreating] = useState(false);

  const onCreateCampaign = async (formData) => {
    setIsCampaignCreating(true);
    const token = localStorage.getItem("authToken");

    try {
      await axios.post(
        `/api/v1/phr-app/marketing-assets`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      toast.success("Campaign created successfully !");
      getAllCampaigns();
      setTimeout(() => {
        onCloseModal();
        onReset();
      }, 1000);
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      }
    } finally {
      setIsCampaignCreating(false);
    }
  };

  return {
    onCreateCampaign,
    isCampaignCreating,
  };
};

export default useCreateCampaign;

